/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Placeholder_CvrInputs */

const da_legal_placeholder_cvr = /** @type {(inputs: Legal_Placeholder_CvrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[CVR-nummer]`)
};

/** @type {(inputs: Legal_Placeholder_CvrInputs) => LocalizedString} */
const en_legal_placeholder_cvr = da_legal_placeholder_cvr;

/**

* @param {Legal_Placeholder_CvrInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_placeholder_cvr = /** @type {((inputs?: Legal_Placeholder_CvrInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Placeholder_CvrInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_placeholder_cvr(inputs)
	return /** @type {LocalizedString} */ ("[CVR-nummer]")
});